import { AccountAutocomplete } from "common/component/AccountAutocomplete";
import { AccountTagList } from "common/component/AccountTagList";
import { AutoCompleteProps } from "common/component/Autocomplete/types";
import { TagListProps } from "common/component/TagList/types";
import { fromStyleLocals } from "common/css";
import { State } from "common/picker/reducer/types";
import { ClientDto, SearchCriteria } from "common/types/account";
import { Component, h } from "preact";

import * as stylesheet from "./AccountTagPicker.less";
const css = fromStyleLocals(stylesheet.locals);
import * as tagListStyle from "common/component/TagList/TagList.less";
import { defaultTo } from "lodash";
import { onClick } from "common/picker/utils";
const tagListCss = fromStyleLocals(tagListStyle.locals);

export interface AccountTagPickerProp
  extends TagListProps<ClientDto, SearchCriteria>,
    AutoCompleteProps<ClientDto, SearchCriteria> {
  onBlur: () => void;
  onStart: () => void;
  criteria: SearchCriteria;
  hostName: string;
  displayInline?: boolean;
  maxItemNameLength?: number;
}

export class AccountTagPicker extends Component<
  AccountTagPickerProp & State<ClientDto, SearchCriteria>,
  {}
> {
  constructor(props: any) {
    super(props);
  }

  public render() {
    const {
      onFocus,
      onInput,
      onRemove,
      onSelect,
      criteria,
      displayInline,
      tagList,
      maxItemNameLength,
      autocomplete,
    } = this.props;

    const {
      disabled,
      hasPortfolio,
      tags,
      placeholder,
      displaySearchBy,
      selectedSearchBy,
      state,
    } = defaultTo(tagList, {
      disabled: false,
      hasPortfolio: true,
      tags: [],
      placeholder: "",
      displaySearchBy: true,
      selectedSearchBy: "id",
      state: "empty" as any,
    });

    const { exclude, isVisible, items, status, reason } = defaultTo(
      autocomplete,
      {
        exclude: [],
        isVisible: false,
        items: [],
        status: "empty" as any,
        reason: "",
      }
    );

    const hasError = status === "error" || state === "error";
    const pickerState = hasError ? "error" : state;
    const TagPickerClasses = [
      "ic-tag-picker",
      ...(pickerState && pickerState !== "empty"
        ? [tagListCss("has-" + pickerState)]
        : []),
    ];

    return (
      <div class={css(...TagPickerClasses)}>
        <style>{stylesheet.toString()}</style>

        <AccountTagList
          maxItemNameLength={maxItemNameLength}
          displayInline={displayInline}
          criteria={criteria}
          disabled={disabled}
          displaySearchBy={displaySearchBy}
          selectedSearchBy={selectedSearchBy}
          hasPortfolio={hasPortfolio}
          onFocus={onFocus}
          onInput={onInput}
          onRemove={onRemove}
          placeholder={placeholder}
          tags={tags}
          state={state}
          status={status}
        />

        <AccountAutocomplete
          criteria={criteria}
          exclude={exclude}
          isVisible={isVisible}
          items={items}
          onSelect={onSelect}
          reason={reason}
          status={status}
        />
      </div>
    );
  }

  public componentDidMount() {
    document.addEventListener("click", this.onClick, false);
    this.props.onStart();
  }

  public componentWillUnmount() {
    document.removeEventListener("click", this.onClick);
  }

  private readonly onClick = (e: MouseEvent) => {
    const clickOutside = onClick(this.base, this.props.hostName, e);
    if (clickOutside) {
      this.props.onBlur();
    }
    return clickOutside;
  };
}
